<template>
    <div>
        <v-card color="#1f1f1f" class="pt-12 pl-12">
            <div v-if="showQuizLayout">
                <br/>

                <v-container fluid>
                    <v-row justify="start" style="width: 300px;">
                        <div style="color: grey; font-family: AirNZ Sans Regular !important; font-size: 14px;">Background Color</div>
                    </v-row>
                    <v-row justify="start" class="pt-2" style="width: 300px;">
                        <!-- Black circle with border -->
                        <div class="circle-black mr-3"
                        :style="formSlides.backgroundColor == 'black' ? 'border: 2px solid #107d82 !important;' : 'border: 1px solid #5d5b5b !important;'"
                        @click="formSlides.backgroundColor = 'black';"></div>
                        <!-- White circle with border -->
                        <div class="circle-white mr-3"
                        :style="formSlides.backgroundColor == 'white' ? 'border: 2px solid #107d82 !important;' : 'border: 1px solid #5d5b5b !important;'"
                        @click="formSlides.backgroundColor = 'white';"></div>
                        <!-- Purple circle with border -->
                        <div class="circle-purple"
                        :style="formSlides.backgroundColor == 'purple' ? 'border: 2px solid #107d82 !important;' : 'border: 1px solid #5d5b5b !important;'"
                        @click="formSlides.backgroundColor = 'purple';"></div>
                    </v-row>
                </v-container>

                <div class="mt-10" style="color: grey; font-family: AirNZ Sans Regular !important; font-size: 20px;">Question Type</div>
                <v-row justify="start" style="width: 600px;" class="pt-8">
                    <!-- Quiz 1 -->
                    <v-col cols="4" style="max-width: 180px;"
                    :style="formSlides.slideLayout == 3 ? 'border: 2px solid #107d82;' : 'border: 1px solid #5d5b5b;'"
                    @click="formSlides.slideLayout = 3; formSlides.type = 'new-training-3'; ">
                        <v-row class="justify-center" style="background-color: #221551; height: 60px;">
                            <v-icon size="50" color="#440099">mdi-image-area</v-icon>
                            <div style="margin-top: 23px; position: absolute;" class="d-flex justify-center">
                            <div
                                style="max-height: 2px; border: 2px solid white; background-color: white; height: 2px; position: absolute; width: 100px;">
                            </div>
                            </div>
                            <div style="margin-top: 35px; position: absolute;" class="d-flex justify-center">
                            <div
                                style="max-height: 2px; border: 2px solid white; background-color: white; height: 2px; position: absolute; width: 100px;">
                            </div>
                            </div>
                        </v-row>
                        <v-row style="background-color: #2d2926; height: 40px;">
                            <!-- <v-col v-for="n in 4" :key="n" cols="3"  class="justify-center"> -->
                            <v-col cols="2" class="d-flex align-start ml-1">
                                <v-icon size="35" color="#440099">mdi-image-area</v-icon>
                            </v-col>
                            <v-col cols="2" v-for="n in 3" :key="n" class="ml-2">
                                <v-icon size="35" color="#440099">mdi-image-area</v-icon>
                            </v-col>
                        </v-row>
                        <v-row style="background-color: #2d2926; height: 32px;">
                            <v-col class="d-flex align-end justify-end mr-2">
                                <div
                                style="max-height: 2px; border: 2px solid #00a0a8; background-color: #00a0a8; height: 2px; width: 20px;">
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>

                    <v-col cols="1" style="max-width: 30px;"></v-col>

                    <!-- Quiz 2 -->
                    <v-col cols="4" style="max-width: 180px;"
                    :style="formSlides.slideLayout == 7 ? 'border: 2px solid #107d82;' : 'border: 1px solid #5d5b5b;'"
                    @click="formSlides.slideLayout = 7; formSlides.type = 'new-training-7'; ">
                    <v-row style="height: 132px;">
                        <v-col cols="12" align-self="center">
                        <div style="margin-bottom: 8px;" class="d-flex justify-center">
                            <div
                                style="max-height: 2px; border: 2px solid white; background-color: white; height: 2px; width: 100px;">
                            </div>
                        </div>
                        <div style="margin-bottom: 8px;" class="d-flex justify-center">
                            <div
                                style="max-height: 2px; border: 2px solid white; background-color: white; height: 2px; width: 100px;">
                            </div>
                        </div>
                        <!--  -->
                        <div style="margin-bottom: 3px; margin-top: 25px;" class="d-flex justify-center">
                            <div
                                class="d-flex justify-center"
                                style="max-height: 7px; border: 7px solid #5e5d5d; background-color: #5e5d5d; height: 7px; width: 140px;">
                                <div class="d-flex justify-center" style="margin-top:-3px; max-height: 6px; background-color: #2d2926; height: 6px; width: 140px;">
                                </div>
                            </div>
                        </div>
                        <div style="margin-bottom: 3px;" class="d-flex justify-center">
                            <div
                                class="d-flex justify-center"
                                style="max-height: 7px; border: 7px solid #5e5d5d; background-color: #5e5d5d; height: 7px; width: 140px;">
                                <div class="d-flex justify-center" style="margin-top:-3px; max-height: 6px; background-color: #2d2926; height: 6px; width: 140px;">
                                </div>
                            </div>
                        </div>
                        <div style="margin-bottom: 3px;" class="d-flex justify-center">
                            <div
                                class="d-flex justify-center"
                                style="max-height: 7px; border: 7px solid #5e5d5d; background-color: #5e5d5d; height: 7px; width: 140px;">
                                <div class="d-flex justify-center" style="margin-top:-3px; max-height: 6px; background-color: #2d2926; height: 6px; width: 140px;">
                                </div>
                            </div>
                        </div>
                        <!--  -->
                        <div style="margin-top: 12px;" class="d-flex justify-end mr-2">
                            <div
                            style="max-height: 2px; border: 2px solid #00a0a8; background-color: #00a0a8; height: 2px; width: 20px;">
                            </div>
                        </div>
                        </v-col>
                    </v-row>
                    </v-col>
                </v-row>

                <v-container fluid class="mx-0 px-0">
                    <div class="mt-10" style="color: grey; font-family: AirNZ Sans Regular !important; font-size: 20px;">Question</div>
                    <v-row>
                        <v-col cols="12" sm="12">
                        <v-text-field label="Question" style="font-size: 14px;" v-model="formSlides.heading" class="white--text"
                            dark></v-text-field>
                        </v-col>
                    </v-row>
                     <!-- Question Picture Start -->

                    <v-row justify="start" class="pt-2" style="width: 700px;">
                        <v-btn v-if="$root.isBlank(formSlides.imageNameQuestion) && openAddImageFromLibrary == false" outlined class="mr-4 white--text" height="45" width="200" @click="showImageLib('image1')">
                        Add Image from library
                        </v-btn>
                        <v-btn v-if="$root.isBlank(formSlides.imageNameQuestion) && openUploadNewImage == false" outlined class="mr-4 white--text" height="45" width="200" @click="openFileDialog()">
                        Upload new image
                        </v-btn>
                        <input type="file" ref="attachment2" accept="image/png, image/jpeg, image/jpg" style="display: none;"
                            required />

                        <template v-if="!$root.isBlank(formSlides.imageNameQuestion) && !$root.isBlank(attachment2)">
                        <v-col>
                            <v-text-field v-model="formSlides.imageNameQuestion" label="Upload Background Image"
                            prepend-icon="mdi-file" readonly dark />
                        </v-col>
                        <v-col cols="auto"> 
                            <v-icon color="duoQuaternary" class="mb-0 white--text"
                            @click="attachment2 = null; formSlides.imageNameQuestion = ''; refresh();">mdi-trash-can</v-icon>
                        </v-col>
                        </template>
                    </v-row>

                     <!-- Finish -->
                </v-container>

                <v-container fluid class="mx-0 px-0">
                    <div class="mt-10" style="color: grey; font-family: AirNZ Sans Regular !important; font-size: 20px;">Answer</div>
                    <v-row>
                        <v-col cols="12" sm="12">
                        <v-text-field label="Answer1" style="font-size: 14px;" v-model="formSlides.heading" class="white--text mr-10"
                            dark></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col>
                            <!-- Answer 1  Picture Start -->
                            
                            <v-row justify="start" class="pt-2" style="width: 700px;">
                                <v-btn v-if="$root.isBlank(formSlides.imageNameAnswer1) && openAddImageFromLibrary == false" outlined class="mr-4 white--text" height="45" width="200" @click="showImageLib('image1')">
                                Add Image from library
                                </v-btn>
                                <v-btn v-if="$root.isBlank(formSlides.imageNameAnswer1) && openUploadNewImage == false" outlined class="mr-4 white--text" height="45" width="200" @click="openFileDialog()">
                                Upload new image
                                </v-btn>
                                <input type="file" ref="attachment2" accept="image/png, image/jpeg, image/jpg" style="display: none;"
                                    required />

                                <template v-if="!$root.isBlank(formSlides.imageNameAnswer1) && !$root.isBlank(attachment2)">
                                <v-col>
                                    <v-text-field v-model="formSlides.imageNameAnswer1" label="Upload Background Image"
                                    prepend-icon="mdi-file" readonly dark />
                                </v-col>
                                <v-col cols="auto"> 
                                    <v-icon color="duoQuaternary" class="mb-0 white--text"
                                    @click="attachment2 = null; formSlides.imageNameAnswer1 = ''; refresh();">mdi-trash-can</v-icon>
                                </v-col>
                                </template>
                            </v-row>

                            <!-- Finish  -->
                        </v-col>
                        <v-col class="d-flex justify-end mr-10">
                            <v-checkbox v-model="formSlides.correctAnswer" value="1" label="Correct answer"
                                dark></v-checkbox>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="12">
                        <v-text-field label="Answer2" style="font-size: 14px;" v-model="formSlides.heading" class="white--text mr-10"
                            dark></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col>
                            <!-- Answer 2 Picture Start -->
                            
                            <v-row justify="start" class="pt-2" style="width: 700px;">
                                <v-btn v-if="$root.isBlank(formSlides.imageNameAnswer2) && openAddImageFromLibrary == false" outlined class="mr-4 white--text" height="45" width="200" @click="showImageLib('image1')">
                                Add Image from library
                                </v-btn>
                                <v-btn v-if="$root.isBlank(formSlides.imageNameAnswer2) && openUploadNewImage == false" outlined class="mr-4 white--text" height="45" width="200" @click="openFileDialog()">
                                Upload new image
                                </v-btn>
                                <input type="file" ref="attachment2" accept="image/png, image/jpeg, image/jpg" style="display: none;"
                                    required />

                                <template v-if="!$root.isBlank(formSlides.imageNameAnswer2) && !$root.isBlank(attachment2)">
                                <v-col>
                                    <v-text-field v-model="formSlides.imageNameAnswer2" label="Upload Background Image"
                                    prepend-icon="mdi-file" readonly dark />
                                </v-col>
                                <v-col cols="auto"> 
                                    <v-icon color="duoQuaternary" class="mb-0 white--text"
                                    @click="attachment2 = null; formSlides.imageNameAnswer2 = ''; refresh();">mdi-trash-can</v-icon>
                                </v-col>
                                </template>
                            </v-row>

                            <!-- Finish  -->
                        </v-col>
                        <v-col class="d-flex justify-end mr-10">
                            <v-checkbox v-model="formSlides.correctAnswer" value="2" label="Correct answer"
                                dark></v-checkbox>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="12">
                        <v-text-field label="Answer3" style="font-size: 14px;" v-model="formSlides.heading" class="white--text mr-10"
                            dark></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col>
                            <!-- Answer 3 Picture Start -->
                            
                            <v-row justify="start" class="pt-2" style="width: 700px;">
                                <v-btn v-if="$root.isBlank(formSlides.imageNameAnswer3) && openAddImageFromLibrary == false" outlined class="mr-4 white--text" height="45" width="200" @click="showImageLib('image1')">
                                Add Image from library
                                </v-btn>
                                <v-btn v-if="$root.isBlank(formSlides.imageNameAnswer3) && openUploadNewImage == false" outlined class="mr-4 white--text" height="45" width="200" @click="openFileDialog()">
                                Upload new image
                                </v-btn>
                                <input type="file" ref="attachment2" accept="image/png, image/jpeg, image/jpg" style="display: none;"
                                    required />

                                <template v-if="!$root.isBlank(formSlides.imageNameAnswer3) && !$root.isBlank(attachment2)">
                                <v-col>
                                    <v-text-field v-model="formSlides.imageNameAnswer3" label="Upload Background Image"
                                    prepend-icon="mdi-file" readonly dark />
                                </v-col>
                                <v-col cols="auto"> 
                                    <v-icon color="duoQuaternary" class="mb-0 white--text"
                                    @click="attachment2 = null; formSlides.imageNameAnswer3 = ''; refresh();">mdi-trash-can</v-icon>
                                </v-col>
                                </template>
                            </v-row>

                            <!-- Finish -->
                        </v-col>
                        <v-col class="d-flex justify-end mr-10">
                            <v-checkbox v-model="formSlides.correctAnswer" value="3" label="Correct answer"
                                dark></v-checkbox>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="12">
                        <v-text-field label="Answer4" style="font-size: 14px;" v-model="formSlides.heading" class="white--text mr-10"
                            dark></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col>
                            <!-- Answer 4 Picture Start -->
                            
                            <v-row justify="start" class="pt-2" style="width: 700px;">
                                <v-btn v-if="$root.isBlank(formSlides.imageNameAnswer4) && openAddImageFromLibrary == false" outlined class="mr-4 white--text" height="45" width="200" @click="showImageLib('image1')">
                                Add Image from library
                                </v-btn>
                                <v-btn v-if="$root.isBlank(formSlides.imageNameAnswer4) && openUploadNewImage == false" outlined class="mr-4 white--text" height="45" width="200" @click="openFileDialog()">
                                Upload new image
                                </v-btn>
                                <input type="file" ref="attachment2" accept="image/png, image/jpeg, image/jpg" style="display: none;"
                                    required />

                                <template v-if="!$root.isBlank(formSlides.imageNameAnswer4) && !$root.isBlank(attachment2)">
                                <v-col>
                                    <v-text-field v-model="formSlides.imageNameAnswer1" label="Upload Background Image"
                                    prepend-icon="mdi-file" readonly dark />
                                </v-col>
                                <v-col cols="auto"> 
                                    <v-icon color="duoQuaternary" class="mb-0 white--text"
                                    @click="attachment2 = null; formSlides.imageNameAnswer4 = ''; refresh();">mdi-trash-can</v-icon>
                                </v-col>
                                </template>
                            </v-row>

                            <!-- Finish -->
                        </v-col>
                        <v-col class="d-flex justify-end mr-10">
                            <v-checkbox v-model="formSlides.correctAnswer" value="4" label="Correct answer"
                                dark></v-checkbox>
                        </v-col>
                    </v-row>
                </v-container>

            </div>


            <!-- Slides List -->
            <div else>
                <v-row align="center" justify="space-between">
                    <v-col cols="9" >
                        <h2 class="white--text pl-5" style="font-family: AirNZ Sans Semibold !important;">Slide Layout</h2>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col v-if="!showQuizLayout">
                        <v-btn color="#440099" class="white--text" height="42" width="120" @click="showQuizLayout = true">Add new</v-btn>
                    </v-col>
                </v-row>

                <v-container v-if="moduleId" fluid>
                    <!-- <draggable v-if="isLoaded" v-bind="dragOptions" v-model="slideList" class="row justify-start"> -->
                    <draggable v-bind="dragOptions" v-model="slideList" class="row justify-start">
                        <v-col cols="4" class="my-0 py-0" v-for="(page, index) in slideList" :key="index + 0">
                        <v-card dark flat rounded="0" height="100%"
                            @click="$router.push('/administration/duoTrainingModule/' + moduleId + '/page/' + page.id + '/configuration')">
                            <v-card-text class="ma-0 pa-0" style="cursor: move;">
                            <div v-for="pageType in pageTypeStaticData" :key="pageType.type">
                                <v-img v-if="page.type === pageType.type" :src="pageType.srcImage" contain eager
                                style="border: 1px solid white;"></v-img>
                            </div>
                            </v-card-text>
                            <v-card-actions>
                            <v-row class="d-flex" justify="space-between">
                                <v-col cols="10">
                                <div v-for="pageType in pageTypeStaticData" :key="pageType.type">
                                    {{ validateTitle(page, pageType, index) }} 
                                </div>
                                </v-col>
                                <v-col cols="2">
                                <v-btn fab right x-small elevation="1" style="right: -8px;" @click.stop="showDeletePage(page)">
                                    <v-icon class="icon-tm-delete pb-2" size="14"></v-icon>
                                </v-btn>
                                </v-col>
                            </v-row>
                            </v-card-actions>
                        </v-card>
                        </v-col>
                    </draggable>
                    <!-- <v-row v-else>
                        <v-col height="260" class="col-12 col-sm-6 col-md-4 col-lg-3" v-for="n in 8" :key="n">
                        <v-skeleton-loader class="mx-auto" type="list-item-two-line, image"></v-skeleton-loader>
                        </v-col>
                    </v-row> -->
                </v-container>
            </div>
        </v-card>

        <v-dialog v-model="dialogPageDelete" max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Delete {{ title }}</span>
                </v-card-title>
                <v-card-text>Are you sure you want to delete slide '{{ page.valueMap.headerTitle }}' ?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="dialogPageDelete = false">Cancel</v-btn>
                    <v-btn @click="deletePage()" color="accent">Delete</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <dialog-images-picker :show="dialogLibrary.show" :list="dialogLibrary.list" @onClickImage="onSelectImage"
            @onCloseDialog="dialogLibrary.show = false" />
    </div>
</template>

<script>
/* eslint-disable no-console */
import axios from "axios";
import draggable from "vuedraggable";
import dialogImagesPicker from "../dialog/dialogImagesPicker.vue"
export default {
    components: {
        draggable,
        dialogImagesPicker
    },
    props: ["showQuizLayout", "formSlides", "pageList", "moduleId"],
    computed: {
		dragOptions() {
			return {
				animation: 200,
				group: "description",
				disabled: false,
				ghostClass: "ghost"
			};
		},
		isLoaded() {
			return !this.$root.isBlank(this.trainingModule);
		}
	},
    data: function() {
        return {
            openUploadNewImage: false,
            openAddImageFromLibrary: false,
            dialogLibrary: {
                show: false,
                target: '',
                list: [],
                idx: undefined,
            },
            attachment2: null,

            slideList: [],
            dialogPageDelete : false,
            title: 'page',
            pageTypeStaticData: [
                { type: "start-1", title: "Start 1 Page", srcImage: "/template/anz-training-start-1.jpg" },
                { type: "start-2", title: "Start 2 Page", srcImage: "/template/anz-training-start-2.jpg" },
                { type: "start-3", title: "Start 3 Page", srcImage: "/template/anz-training-start-3.jpg" },
                { type: "info-image-1", title: "Information Image 1 Page", srcImage: "/template/anz-training-info-image-1.jpg" },
                { type: "info-image-2", title: "Information Image 2 Page", srcImage: "/template/anz-training-info-image-2.jpg" },
                { type: "info-image-3", title: "Information Image 3 Page", srcImage: "/template/anz-training-info-image-3.jpg" },
                { type: "info-image-4", title: "Information Image 4 Page", srcImage: "/template/anz-training-info-image-4.jpg" },
                { type: "info-image-5", title: "Information Image Full Page", srcImage: "/template/anz-training-info-image-5.jpg" },
                { type: "info-video-1", title: "Information Video 1 Page", srcImage: "/template/anz-training-info-video-1.jpg" },
                { type: "info-video-2", title: "Information Video 2 Page", srcImage: "/template/anz-training-info-video-2.jpg" },
                { type: "info-text-1", title: "Information Text 1 Page", srcImage: "/template/anz-training-info-text-1.jpg" },
                { type: "info-text-2", title: "Information Text 2 Page", srcImage: "/template/anz-training-info-text-2.jpg" },
                { type: "multiple-choice-1", title: "Multiple Choice 1 Page", srcImage: "/template/anz-training-question-multiple-choice-1.jpg" },
                { type: "multiple-choice-2", title: "Multiple Choice 2 Page", srcImage: "/template/anz-training-question-multiple-choice-2.jpg" },
                { type: "short-answer", title: "Short Answer Page", srcImage: "/template/anz-training-question-short-answer.jpg" },
                { type: "free-answer", title: "Free Answer Page", srcImage: "/template/anz-training-question-short-answer.jpg" },

                //{ type: "new-training-", title: "Slide Title", srcImage: "/template/new-training.jpg" },

                { type: "new-quiz-1", title: "Slide Title", srcImage: "/template/new-training-1.jpg" },
                { type: "new-quiz-2", title: "Slide Title", srcImage: "/template/new-training-2.jpg" },
                { type: "new-quiz-3", title: "Slide Title", srcImage: "/template/new-training-1.jpg" },
            ],
            page: {
				valueMap: {
					headerTitle: "",
					headerBackgroundColor: {
						// grey
						hexa: '#424242'
					},
					headerIconColor: {
						// white
						hexa: '#FFFFFFFF'
					},
					headerIconBackgroundColor: {
						// purple
						hexa: '#221551'
					},
					bodySummary: "",
					bodyTip: "",
					bodyNote: "",
					bodyIconTextColor: {
						// white
						hexa: '#FFFFFFFF'
					},
					bodyIconBackgroundColor: {
						// purple
						hexa: '#440099'
					},
					bodyQuestionMultipleChoice: {},
					bodyQuestionShortAnswer: {},
					footerHasBackButton: false,
					footerButtonConfig: "",

                    bodyCopy: "",
                    buttonText: "",
                    slideLayout: 0,
                    backgroundColor: "black",
                    isDisplayAfterQuiz: false,
                    type: '',
                    name: '',

                    correctAnswer: -1,
				}
			},
        }
    },
    mounted: function() {
        this.slideList = [...this.pageList]
	},
    methods: {
        refresh() {
            this.$forceUpdate();
        },
        openFileDialog() {
            if (this.attachment2) {
                this.attachment2.click();
            } else {
                console.error('The attachment2 is not defined');
            }
        },
        onSelectImage(item) {
            let result = this.$bucket + '/' + item;
            this.formSlides.imageName = result
            this.$forceUpdate();
            this.openAddImageFromLibrary = true; 
            this.dialogLibrary.show = false;
        },
        showImageLib(target, idx = undefined) {
            this.dialogLibrary.list = this.pageImageList;
            this.dialogLibrary.show = true;
            this.dialogLibrary.target = target;
            this.dialogLibrary.idx = idx;
        },


        validateTitle(data, pageType, index) {
            var title = pageType.title;
            var header = data.valueMap ? data.valueMap.headerTitle : null;
            if (data.type != pageType.type) {
                return "";
            }
            if (header) {
                var div = document.createElement("div");
                div.innerHTML = header;
                title = div.textContent || div.innerText || "";
            }
            return (index + 1) + ". " + title;
        },
        listPage(id) {
            this.moduleId = id
			axios
				.get("/api/page/module/list?moduleId=" + id)
				.then(response => {

					this.slideList = response.data

				})
				.catch(() => {});
		},
        deletePage() {
			axios
				.post("/api/page/delete?id=" + this.page.id, {})
				.then(() => {
					this.dialogPageDelete = false;
					this.listPage(this.page.moduleId);
				})
				.catch(() => {});
		},
        showDeletePage(item) {
			this.page = this.$root.clone(item);
			this.dialogPageDelete = true;
		},
    }
}
</script>